import React from 'react';
import {Link} from 'react-router-dom';
const IconPositionImage = require('../assets/image/icon-baidu-position.png');

const pageContant={
	pageTitle:{
        chinese:'联系PMS',
        english:'CONTACT PMS'
    },
   crumb:{
		home:{
			name:{
				"chinese":"首页",
				"english":"Home"
			},
			url:'/'
		},
		contact:{
			name:{
				"chinese":"联系",
				"english":"Contact"
			},
			url:'/contact'
		},
		text:{
            "chinese":"正文",
            "english":"Text"
        }
   },
   contentTitle:{
        chinese:'联系我们',
        english:'Contact us'
   },
   company:{
	   name:{
		   chinese:"广州派敏斯速递有限公司",
		   english:"Guangzhou Parcel Mail Service Co.,Limited"
	   },
	   content:{
		   chinese:[{
			   title:"总部",
			   text:"佛山市南海区海五路28号富力国际金融中心A区2栋9层"
		   },{
			   title:"丹灶仓库",
			   text:"佛山市南海区丹灶镇丹横路大涡2号"
		   },
				//  {
			 //   title:"广州仓库:",
			 //   text:"广州龙溪大道裕海路芳村邮政基地二期二楼"
		   // }
		   ],
		   english:[{
			   title:"Headquarter",
			   text:"Floor 9,Block 2,Area A ,28 Haiwu Road, Fuli International Financial Center,Nanhai District,Foshan, Guangdong Province, China"
		   },{
			   title:"Warehouse address(Danzao)",
			   text:"Danzao Warehouse: No. 2, Dafu, Danheng Road, Danzao Town, Nanhai District, Foshan City, Guangdong Province, China"
		   },
				//  {
			 //   title:"Warehouse address(Guangzhou):",
			 //   text:"2nd Floor, Phase II, Postal Base, Fangcun,Yuhai Road,Longxi Avenue,Guangzhou City."
		   // }
		   ]
	   }
   	},
	linkman:{
		departmentName:{
			chinese:"业务部",
			english:"Business Department"
		},
		title:{
			chinese:"联系人",
			english:"Contacts"
		},
		user:[{
			chinese:[{
				title:"业务部",
				text:"Cafen"
			},/* {
				title:"手机",
				text:"18814106377"
			}, */{
				title:"QQ",
				text:"2853275102"
			},{
				title:"邮箱",
				text:"pms01@pms.com.cn"
			}],
			english:[{
				title:"Business Department",
				text:"Cafen"
			},/* {
				title:"Phone",
				text:"18814106377"
			}, */{
				title:"QQ",
				text:"2853275102"
			},{
				title:"Email",
				text:"pms01@pms.com.cn"
			}]
		}/*,{
			chinese:[{
				title:"业务部",
				text:"Wing-庞嘉颖"
			},{
				title:"手机",
				text:"18942482047"
			},{
				title:"QQ",
				text:"875861993"
			},{
				title:"邮箱",
				text:"ring@pms.com.cn"
			}],
			english:[{
				title:"B＆D",
				text:"Wing-Pong"
			},{
				title:"Phone",
				text:"18942482047"
			},{
				title:"QQ",
				text:"875861993"
			},{
				title:"Email",
				text:"ring@pms.com.cn"
			}]
		}*/]
	},
	message:{
		title:{
			chinese:'联系我们:',
			english:'Contact us'
		},
		text:{
			text1:{
				chinese:'派敏斯速递对您提交的个人信息资料采取保密措施，敬请放心。',
				english:'Email us with as much detail as you can so we can give you the best help possible. '
			},
			text2:{
				chinese:'为确保我们能第一时间联系您，请务必准确填写联系方，感谢您的配合。',
				english:''
			}
		},
		placeholder:{
			chinese:{
				username:'您的称呼：*',
				infomation:'您的联系方式：*',
				message:'留言内容：*',
				submit:'提交留言'
			},
			english:{
				username:'Your name',
				infomation:'Your contact information',
				message:'Message',
				submit:'submit'
			}
		}
	}
}
export default class Contact extends React.Component{
	constructor(props){
		super(props);
    }
    componentDidMount() {
		const _this = this;
		if(!!window.BMap){
			this.setMap();
		}else{
			loadMyScript();
		}
		function loadMyScript(){
			if(!!document.querySelector('#baidu')) return;
			var script = document.createElement("script");
			script.id ="baidu";
			script.src = "http://api.map.baidu.com/api?v=2.0&ak=b4CZsj1WVarqlCsZ94xTdxtN&callback=initialize";
			document.body.appendChild(script);
			window.initialize= function(){
				_this.setMap();
			}
		}

	}
	setMap(){
		var map = new BMap.Map('pms-map');
		var point=new BMap.Point(113.15657,23.06016);
		map.centerAndZoom(point,20);
		map.addOverlay(point);
		map.enableScrollWheelZoom();   //启用滚轮放大缩小，默认禁用
		map.enableContinuousZoom();    //启用地图惯性拖拽，默认禁用
		var pointCenter = map.getCenter();

        //创建圆对象
        var myIcon = new BMap.Icon(IconPositionImage, new BMap.Size(46, 124),{
			imageOffset:new BMap.Size(0, 0)
		});
		//画到地图上面
		var marker=new BMap.Marker(point,{icon:myIcon});
        map.addOverlay(marker);
	}
	render(){
		const {language} = this.props;
		return(
			<div className="pms-container pms-contact">
				<div className="page-banner">
					<img src={require('../assets/image/contact-banner.png')} alt=""/>
					<p className="pms-common-title"><span></span> {pageContant.pageTitle[language]}</p>
				</div>
				<div className="page-crumbs">
                    <span><Link to="/">{pageContant.crumb.home.name[language]}</Link> &gt;</span>
                    <span><Link to="/contact">{pageContant.crumb.contact.name[language]}</Link> &gt;</span>
                    <span>{pageContant.crumb.text[language]}</span>
                </div>
				<h1 className="page-head-title">
                    <span className="sub-logo">
						<img src={require('../assets/image/logo.png')} alt=""/>
                    </span>
                    {pageContant.contentTitle[language]}
                </h1>
				<div id="pms-map"></div>
				<div className="pms-common-title">
					<span className="pms-square"></span>
					{pageContant.company.name[language]}
				</div>
				<div className="pms-contact-info-list">
					{pageContant.company.content[language].map((value,index)=>
						<p className="pms-name-in-info" key={index.toString()}><span>{value.title}：</span>{value.text}</p>
					)}
				</div>
				<div className="pms-common-title">
					<span className="pms-square"></span>
					{pageContant.linkman.title[language]}
				</div>
				<div className="pms-circle-list clear">
					{pageContant.linkman.user.map((value,index)=>
						<div className="col-xs-4" key={index.toString()}>
							<div>
								<p className="pms-name-in-info">{pageContant.linkman.departmentName[language]}</p>

								{value[language].map((val,key)=>{
									if(key==0){
										return (<p className="pms-name-in-info" key={key.toString()}>{val.text}</p>)
									}else{
										return (<p className="pms-name-in-info" key={key.toString()}><span>{val.title}：</span>{val.text}</p>)
									}
								})}

							</div>
						</div>
					)}


				</div>
				<div className="pms-contact-form">
					<p className="contact-form-title">{pageContant.message.title[language]}</p>
					<p className="contact-form-tips">{pageContant.message.text.text1[language]}</p>
					<p className="contact-form-tips">{pageContant.message.text.text2[language]}</p>
					<form action="">
						<div className="clear">
							<div className="col-xs-5"><input type="text" placeholder={pageContant.message.placeholder[language].username}/></div>
							<div  className="col-xs-2"></div>
							<div className="col-xs-5"><input type="text" placeholder={pageContant.message.placeholder[language].infomation}/></div>
						</div>
						<div className="clear">
							<textarea name="" id="" cols="30" rows="5" placeholder={pageContant.message.placeholder[language].message}></textarea>
						</div>
						<div className="clear form-submit">
							<div className="col-xs-9"></div>
							<div className="col-xs-3">
								<button type="button">{pageContant.message.placeholder[language].submit}</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./public/views/contact.js